module.exports = __webpack_public_path__ + "img/ACLEDSources.ad2ced30.png";